<template>
  <div>
    <div v-if="formKey === 'brand_url'">
      <div class="flex">
        <el-image v-show="formItem.value" class="mr-10 icon inline-block" fit="cover" :src="formItem.value" />
        <div>
          <el-button v-if="!formItem.isPreview" size="mini" type="primary" @click="openMaterialBox('image', formItem)">{{ formItem.value ? '替换' : '选择品牌' }}头像</el-button>
        </div>
      </div>
      <!-- 素材弹框 -->
      <material-box
        v-if="formItem.is_open"
        advertiser="baidu"
        :is-open="formItem.is_open"
        :type="formItem.box_type"
        :temp-material="formItem.temp_material"
        :material-restriction="formItem.material_restriction"
        @confirm="(m_data) => materialConfirm({ data: m_data, material: formItem })"
        @cancel="materialCancel(formItem)"
      />
    </div>
  </div>
</template>

<script>
import { component_props } from '@/views/fusion/investment/intelligence-create/components/main-view/components/step-form/model/props';

export default {
  components: {
    'material-box': () => import('@/components/material-box'),
  },
  props: {
    ...component_props,
  },
  methods: {
    /**
     * 打开素材框
     * @param {string} type 素材类型
     * @param {string} material_item 当前素材
     * @returns {void}
     */
    openMaterialBox(type, material_item) {
      if (material_item) {
        material_item.temp_material = null;
        material_item.is_open = true;
        material_item.box_type = material_item.element_type || type;
      }
    },

    /**
     * 素材资源确定返回
     * @param {Array<Object>} data 素材数据
     * @param {Object} material 表单配置项
     * @returns {void}
     */
    async materialConfirm({ data, material }) {
      material.is_open = false;

      if (data.length === 0) {
        return;
      }

      if ((data.length > material.limit) && !material.temp_material) {
        this.$message.warning(`品牌头像不能超过${material.limit}个！`);
        return;
      }
      material.value = data[0].url[0].url;
      this.$parent.$parent.$parent.$parent.$parent.validateField('brand.children.brand_url.value');
    },

    /**
     * 素材资源取消返回
     * @param {Object} material 素材配置项
     * @returns {void}
     */
    materialCancel(material) {
      material.is_open = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.icon {
  width: 100px;
  height: 100px;
  font-size: 0;
}
</style>
